import { StyleSheet } from 'react-native-unistyles';

export const styles = StyleSheet.create({
  widgetRoot: {
    flex: 1,
  },
});
